import React, { Component } from 'react';

class Loading extends Component {
  render() {
    const LayoutWrapper = this.props.layout

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Loading...</h2>
        </div>
      </LayoutWrapper>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/pages/loading.js